import styled from 'styled-components';

import { COLORS } from '@r1-frontend/ui-react/assets/js/constants';
import { BaseButton } from '@r1-frontend/ui-react/components/buttons/baseButton';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

export const Container = styled.div<{ fill?: string, transitionDelay?: number }>`
    width: 100%;
    padding: 0 150px;
    box-sizing: border-box;
    background: ${ ({ fill }) => fill ? fill : COLORS.white };
    box-shadow: 0 4px 4px rgba(0, 0, 0, 0.03);
    height: 68px;
    justify-content: space-between;
    align-items: center;
    transition: all 0.4s ease-in-out;
    flex-wrap: nowrap;
    transition-delay: ${ ({ transitionDelay }) => transitionDelay ? `${transitionDelay}s` : '0s' };

    @media (max-width: 1400px) {
        height: 55px;
        padding: 0 115px;
    }
    @media (max-width: 1000px) {
        padding: 0 60px;
    }
    @media (max-width: 600px) {
        padding: 0 20px;
    }
`;

export const ActionButton = styled(BaseButton)`
    @media (max-width: 1400px) {
        height: 33px;
        padding: 4px 15px;
    }
`;

export const Title = styled.div<{ styles: { fontColor: string }, transitionDelay: number }>`
    ${FONTS.XXL};
    color: ${p => p.styles.fontColor };
    transition: color 0.4s ease-in-out;
    transition-delay: ${p => p.transitionDelay ? p.transitionDelay : 0 }s;

    @media (max-width: 1400px) {
        ${FONTS.L};
    }
    @media (max-width: 600px) {
        ${FONTS.XS};
    }
`;

export const MenuContainer = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
`;

export const MenuItem = styled.div<{
    styles: { fontColor: string, activeItem?: string },
    activeElem: boolean,
    transitionDelay: number,
}>`
    margin-right:45px;
    cursor: pointer;
    text-decoration: none;
    color:  ${ ({ activeElem, styles }) => activeElem ? styles.activeItem : styles.fontColor };
    transition: color 0.4s ease-in-out;
    transition-delay: ${ ({ transitionDelay }) => transitionDelay ? `${transitionDelay}s` : '0s' };
    ${FONTS.S};
    @media (max-width: 1400px) {
        margin-right: 25px;
    }
    @media (max-width: 1100px) {
        display: none;
    }
`;

export const MenuList = styled.div`
    display: flex;
`;
